import React from 'react';
import { AccountBlock } from './AccountBlock';
import { Navigation } from './Navigation';
import { UserBlock } from './UserBlock';
import { UserMenuSkeleton } from './UserMenuSkeleton';
import { WorkspaceMenuSkeleton } from './WorkspaceMenuSkeleton';
import { WorkspaceSelectorSkeleton } from './WorkspaceSelectorSkeleton';

export const LoadingNavigationView = () => {
    return <Navigation>
        <Navigation.Section>
            <AccountBlock />
            <UserMenuSkeleton />
        </Navigation.Section>
        <Navigation.Divide />
        <Navigation.Section grow>
            <WorkspaceSelectorSkeleton />
            <WorkspaceMenuSkeleton />
        </Navigation.Section>
        <Navigation.Divide />
        <Navigation.Section end>
            <UserBlock />
        </Navigation.Section>
    </Navigation >;
};
